module.exports = __webpack_public_path__ + "img/bg_sr.9a534f79.png";